import React, { FC } from 'react';
import cx from 'classnames';

import { usePriceCustomizer } from '../PriceCustomizerContext';
import { PaymentPlanOption } from './PaymentPlanOption';
import {
  PaymentConceptName,
  PlanComparisonProps,
  PlanComparisonVariant,
} from './types';
import styles from './styles.module.css';

const installmentConceptsSequence: Array<PaymentConceptName | null> = [
  'downpayment',
  'installment',
  'total',
];

const inFullConceptsSequence: Array<PaymentConceptName | null> = [
  'downpayment',
  null, // Null entries create visual spacing
  'total',
];

const gridConceptsSequence: Array<PaymentConceptName | null> = [
  'downpayment',
  'installment',
  'total',
];

const getBreakdownSequence = (
  planName: string,
  variant: PlanComparisonVariant
): Array<PaymentConceptName | null> => {
  if (variant === 'grid') {
    return gridConceptsSequence;
  }

  return planName === 'fullPay'
    ? inFullConceptsSequence
    : installmentConceptsSequence;
};

export const PlanComparison: FC<PlanComparisonProps> = ({
  isLoading,
  selectedLabel,
  variant = 'default',
  conceptLabels,
  onPlanSelect,
}) => {
  const { selectFrequency, frequency, paymentPlanOptions } =
    usePriceCustomizer();

  return (
    <div
      className={cx(styles.planComparison, {
        [styles.gridVariant]: variant === 'grid',
      })}
    >
      {paymentPlanOptions.map((plan) => {
        return (
          <div key={plan.name} className={styles.planListItem}>
            <PaymentPlanOption
              plan={plan}
              selected={plan.name === frequency}
              loading={isLoading}
              selectedLabel={selectedLabel}
              variant={variant}
              conceptLabels={conceptLabels}
              breakdownSequence={getBreakdownSequence(plan.name, variant)}
              onSelect={() => {
                void onPlanSelect(plan.name);
                selectFrequency(plan.name);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};
